import React, { useEffect } from "react"
// ** Custom Components
import Avatar from '@components/avatar'

// ** Store & Actions
import { connect } from "react-redux"
import { appAuthenticateOut, appFetchNavigationProfile } from 'redux/actions/app'

// ** Third Party Components
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'
import { Power } from 'react-feather'

// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/profile/portrait.png'

const UserDropdown = (props) => {
  const { navProfile } = props
  const { appFetchNavigationProfile, appAuthenticateOut } = props

  useEffect(() => {
    appFetchNavigationProfile()
  }, [appFetchNavigationProfile])

  //** Vars
  const userAvatar = defaultAvatar

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name font-weight-bold'>
            {navProfile?.name}
          </span>
          <span className='user-status'>
            {navProfile?.email}
          </span>
        </div>
        <Avatar img={userAvatar} imgHeight='40' imgWidth='40' status='online' />
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem className="w-100" onClick={() => appAuthenticateOut()}>
          <Power size={14} className='mr-75' />
          <span className='align-middle'>Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const mapStateToProps = state => {
  return {
    navProfile: state.app.navProfile
  }
}

export default connect(
  mapStateToProps,
  {
    appFetchNavigationProfile,
    appAuthenticateOut
  }
)(UserDropdown)
